import { ModuleWithProviders } from '@angular/core'
import { Route, RouterModule } from '@angular/router'

import { BlogIndexComponent } from './pages/blog-index/blog-index.component'
import { AiPrincipleDetailComponent } from './resources/ai-principle/ai-principle-detail/ai-principle-detail.component'
import { CountryComponent } from './resources/country/country.component'
import { DocumentDetailComponent } from './resources/document/document-detail/document-detail.component'
import { PolicyAreaDetailComponent } from './resources/policy-area/policy-area-detail/policy-area-detail.component'
import { PostDetailComponent } from './resources/post/post-detail/post-detail.component'
import { TagDetailComponent } from './resources/tag/tag-detail/tag-detail.component'

export const aiWonkBlogRoutes: Route[] = [
  // Blog.
  {
    path: '',
    component: BlogIndexComponent
  },
  {
    path: 'documents/:documentSlug',
    component: DocumentDetailComponent
  },
  {
    path: ':slug',
    component: PostDetailComponent
  },
  {
    path: 'tags/:idAndSlug',
    component: TagDetailComponent
  },
  {
    path: 'ai-principles/:idAndSlug',
    component: AiPrincipleDetailComponent
  },
  {
    path: 'policy-areas/:idAndSlug',
    component: PolicyAreaDetailComponent
  },
  {
    path: 'countries/:idAndSlug',
    component: CountryComponent
  }
]

export const AiWonkBlogRoutingModule: ModuleWithProviders<any> =
  RouterModule.forChild(aiWonkBlogRoutes)
